// components/Purchase/PaymentVerification.jsx

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { verifyPaymentApi } from "../../services/paymentApi";
import { getPaymentStatusDescription } from "../../utils/statusCodes";
import { toPersianDateTime } from "../../utils/dateUtils";
import {
  checkResponseData,
  checkErrorMessage,
} from "../../utils/responseHandler";
import "./PaymentVerification.css";

const PaymentVerification = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [verificationResult, setVerificationResult] = useState(null);
  const [error, setError] = useState("");
  const [statusDescription, setStatusDescription] = useState("");

  useEffect(() => {
    verifyPayment();
  }, [orderId]);

  // PaymentVerification.jsx
  const verifyPayment = async () => {
    try {
      setLoading(true); // ✅ حتماً باید باشه

      const response = await verifyPaymentApi(orderId);

      if (response?.success) {
        setVerificationResult(response);

        // دریافت توضیحات وضعیت
        if (response.resCode) {
          const description = getPaymentStatusDescription(response.resCode);
          setStatusDescription(description);
        }

        // ذخیره توکن جدید
        if (response.token) {
          localStorage.setItem("token", response.token);
        }

        // ❌ این خط رو پاک کردیم - دیگه movieInfoBeforPay رو پاک نمیکنیم
        // localStorage.removeItem("movieInfoBeforPay");

        // ✅ به جاش وضعیت رو ذخیره میکنیم
        localStorage.setItem("lastPaymentStatus", "success");
      } else {
        setError(response?.message || "خطا در تایید پرداخت");
        localStorage.setItem("lastPaymentStatus", "failed");

        if (response.resCode) {
          setStatusDescription(getPaymentStatusDescription(response.resCode));
        }
      }
    } catch (err) {
      const errorDetails = checkErrorMessage(err);
      setError(errorDetails.message || "خطا در تایید پرداخت");
      localStorage.setItem("lastPaymentStatus", "error");
    } finally {
      setLoading(false); // ✅ finally هم باید باشه
    }
  };

  const handleBackToPlayer = () => {
    navigate("/");
  };

  const getStatusClassName = () => {
    if (loading) return "status-loading";
    if (verificationResult?.success) return "status-success";
    return "status-failed";
  };

  const getStatusIcon = () => {
    if (loading) return "⏳";
    if (verificationResult?.success) return "✅";
    return "❌";
  };

  return (
    <div className="payment-verification-container">
      <div className="verification-card">
        <div className={`verification-header ${getStatusClassName()}`}>
          <div className="status-icon">{getStatusIcon()}</div>
          <h2>
            {loading
              ? "در حال تایید پرداخت..."
              : verificationResult?.success
                ? "پرداخت با موفقیت انجام شد"
                : "پرداخت ناموفق"}
          </h2>
        </div>

        <div className="verification-body">
          {loading && (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>لطفا منتظر بمانید...</p>
            </div>
          )}

          {!loading && error && (
            <div className="error-message">
              <p>{error}</p>
            </div>
          )}

          {!loading && verificationResult && (
            <div className="verification-details">
              {/* شماره سفارش */}
              <div className="detail-item">
                <span className="detail-label">شماره سفارش:</span>
                <span className="detail-value order-id">{orderId}</span>
              </div>

              {/* کد وضعیت و توضیحات */}
              {verificationResult.resCode && (
                <div className="detail-item">
                  <span className="detail-label">کد وضعیت:</span>
                  <span className="detail-value">
                    {verificationResult.resCode}
                  </span>
                </div>
              )}

              {statusDescription && (
                <div className="detail-item status-description">
                  <span className="detail-label">توضیحات:</span>
                  <span className="detail-value">{statusDescription}</span>
                </div>
              )}

              {/* شماره پیگیری */}
              {verificationResult.saleReferenceId && (
                <div className="detail-item highlight">
                  <span className="detail-label">شماره پیگیری بانک:</span>
                  <span className="detail-value ref-id">
                    {verificationResult.saleReferenceId}
                  </span>
                </div>
              )}

              {/* پیام سرور */}
              {verificationResult.message && (
                <div className="detail-item message">
                  <span className="detail-label">پیام:</span>
                  <span className="detail-value">
                    {verificationResult.message}
                  </span>
                </div>
              )}
            </div>
          )}

          {/* دکمه بازگشت به پلیر */}
          <button className="back-to-player-btn" onClick={handleBackToPlayer}>
            بازگشت به پلیر
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentVerification;
